var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"practice-detail container"},[_c('div',{staticClass:"box"},[_c('el-page-header',{attrs:{"content":"实战详情"},on:{"back":function($event){return _vm.$router.go(-1)}}}),_c('el-button',{staticClass:"btn",attrs:{"type":"primary","size":"small","disabled":_vm.info.worksStatus == 'SUBMITTED'},on:{"click":function($event){return _vm.$router.push({
          path: '/courseDetail/practice/uploadWorks',
          query: {
            ..._vm.$route.query,
            worksId: _vm.info.worksStatus == 'REDO' ? _vm.info.worksId : null,
          },
        })}}},[_vm._v("提交作品")]),_c('div',{staticClass:"main-area"},[_c('div',{staticClass:"ql-container ql-snow",staticStyle:{"border":"none"}},[_c('div',{staticClass:"ql-editor"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.content)}})])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }